import React from "react";

import "./Analytics.css"
import {checkMikaResponseSuccess, downloadAnalytics} from "./RestApi";

const {Parser} = require('json2csv');
const fields = [{value: 'timestamp', label: "TIMESTAMP COMPLETAMENTO"},
    {value: "answered_questions.id", label: "ID DOMANDA"},
    {value: "answered_questions.text", label: "TESTO DOMANDA"},
    {value: "answered_questions.correct", label: "CORRETTA"},
    {value: "answered_questions.option", label: "OPZIONE SCELTA"}];
const json2csvParser = new Parser({fields, unwind: ['answered_questions'], unwindBlank: true});

export function DownloadAnalyticsButton(props) {
    async function handleClick() {
        const resp = await downloadAnalytics();
        if (await checkMikaResponseSuccess(resp)) {
            const csv = json2csvParser.parse(resp.analytics);
            const FileSaver = require('file-saver');
            const blob = new Blob([csv]);
            FileSaver.saveAs(blob, "Analytics.csv");
        }
    }

    return (
        <button className="analyticsButton" onClick={handleClick}>Download Analytics</button>
    );
}